module.exports = __webpack_public_path__ + "2ccb0d7b9c1788ac1ceff2c502d16e16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bg.jpg
// module id = 4
// module chunks = 0 1 2